document.addEventListener("DOMContentLoaded", () => {
    let gallery = document.querySelector('.square-gallery');
    if (gallery) {
        let objectSlider = new Gallery(gallery);
        objectSlider.init();
    }
});

class Gallery {
    constructor(slider) {
        this.slider = slider;
        this.slider_wrap = slider.querySelector('.square-gallery__wrap');
        this.slider_items = slider.querySelectorAll('.square-gallery__item');
        this.count_slider_items = this.slider_items.length;
        this.index = 0;
        this.animate = false;
    }

    init() {
        this.bindArrows();
        this.getCountViewColumns();
        this.getCountColumns();
        this.toggleArrows();

        this.setWrapWidth();

        let that = this;
        window.addEventListener('resize', () => {
            that.setWrapWidth();
            that.getCountViewColumns();
            that.toggleArrows();
            that.resetSlider();
        });
    }

    resetSlider() {
        this.index = 0;
        this.slider_wrap.style.marginLeft = '0px';
    }

    slide(direction) {
        if (this.animate) {
            return;
        }
        this.animate = true;

        let slideCount = this.count_columns - this.count_view_columns + 1;

        if (direction === 'left') {
            this.index = (this.index - 1) < 0 ? slideCount - 1 : (this.index - 1);
        } else if (direction === 'right') {
            this.index = (this.index + 1) > slideCount - 1 ? 0 : (this.index + 1);
        }

        this.animate = true;

        let width = ((this.slider.querySelector('.square-gallery__slide').clientWidth - (20 * (this.count_view_columns - 1))) / this.count_view_columns) + 20;
        this.slider_wrap.style.marginLeft = (this.index * -width) + 'px';

        let that = this;
        setTimeout(function () {
            that.animate = false;
        }, 150);
    }

    bindArrows() {
        let buttons = this.slider.querySelector('.square-gallery__buttons');
        let leftArrow = buttons.querySelector('.square-gallery__buttons-left');
        let rightArrow = buttons.querySelector('.square-gallery__buttons-right');

        leftArrow.addEventListener('click', () => {
            this.slide('left');
        });
        rightArrow.addEventListener('click', () => {
            this.slide('right');
        });

    }

    setWrapWidth() {
        let viewColumns = this.count_view_columns;
        let width = (this.slider.querySelector('.square-gallery__slide').clientWidth - (20 * (viewColumns - 1))) / viewColumns;
        this.slider_wrap.style.gridTemplateColumns = "repeat(" + this.count_columns + "," + width + "px)";
    }

    getCountColumns() {
        this.count_columns = Math.ceil((this.count_slider_items - 1) / 2 + 2);
    }

    getCountViewColumns() {
        let width = window.innerWidth;
        if (width > 1350) {
            this.count_view_columns = 5;
        } else if (width > 991) {
            this.count_view_columns = 5;
        } else if (width > 768) {
            this.count_view_columns = 4;
        } else if (width > 575) {
            this.count_view_columns = 3;
        } else {
            this.count_view_columns = 2;
        }
    }

    toggleArrows() {
        let needSlide = this.count_columns - this.count_view_columns;
        if (needSlide > 0) {
            this.slider.querySelector('.square-gallery__buttons').classList.remove('hidden');
        } else {
            this.slider.querySelector('.square-gallery__buttons').classList.add('hidden');
        }

    }
}
